import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { usePathname } from '../../hooks/use-pathname';
import { useResponsive } from '../../hooks/use-responsive';

import { NAV, HEADER } from './config-layout';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }) {
    const lgUp = useResponsive('up', 'lg');

    const pathname = usePathname();
    const isChat = (pathname.split('/')[1] === 'chat' && pathname.split('/')[2] !== undefined) || pathname === '/chat';

    return (
        <Box
            component='main'
            sx={{
                flexGrow: 1,
                minHeight: 1,
                display: 'flex',
                flexDirection: 'column',
                py: isChat ? '0px' : `${HEADER.H_MOBILE + SPACING}px`,
                ...(lgUp && {
                    px: 2,
                    py: isChat ? '0px' : `${HEADER.H_DESKTOP + SPACING}px`,
                    width: `calc(100% - ${NAV.WIDTH}px)`,
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
}

Main.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
};
